module.exports = __webpack_public_path__ + "img/notification-icon.e4e6325f.svg";